import { useMutation } from "@tanstack/react-query";
import { downloadCurrentLegalCompliance } from "@/features/legal/services/legalCompliance.service";
import type { LegalCompliance } from "@/features/legal/types/legalCompliance.type";
import { downloadFile } from "@/shared/utils/file.util";

const buildFilename = (versionLabel: string): string => `cgu-yeati-${versionLabel}.html`;

// Downloads the exact copy of the version displayed. Errors stay local to
// the step: no global toast on top of the inline message.
export const useLegalComplianceDownload = () => {
  const mutation = useMutation({
    mutationFn: (legalCompliance: Pick<LegalCompliance, "version" | "version_label">) =>
      downloadCurrentLegalCompliance(legalCompliance.version),
    onSuccess: (blob, legalCompliance) => downloadFile({ resource: blob, filename: buildFilename(legalCompliance.version_label) }),
    // Overrides the default mutation handler: the step shows its own message.
    onError: () => undefined,
  });

  return {
    download: mutation.mutate,
    isDownloading: mutation.isPending,
    hasDownloadError: mutation.isError,
  };
};
